export class UserFeature {
  id?: string;
  name: string;

  constructor(name) {
    this.name = name;
  }

}
